<div class="title-box p-3">
    <div class="title mx-auto" i18n="terms: page title">Cookie Notice</div>
</div>
<section class="section-about">
    <div class="container">
        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Cookie Notice </h6>
            <p>At the Dhammika & Priscilla Perera Foundation, we utilize cookies and similar technologies on our website (www.dpeducation.org) to enhance your browsing experience and support our mission of providing accessible, high-quality education. This notice outlines the types of cookies we use, their purposes, and how you can manage your preferences.</p>
        </div>

        <div class="inner mb-4">
            <h6 class="mb-4">1. What Are Cookies?</h6>
            <p>Cookies are small text files placed on your device when you visit our website. They collect information about your browsing activities, helping us understand user interactions, remember your preferences, and improve our services.</p>
        </div>

        <div class="inner mb-4">
            <h6 class="mb-4">2. Types of Cookies We Use </h6>
            <ul>
                <li>
                    <b>Strictly Necessary Cookies:</b>
                    These cookies are essential for the basic functionality of our website, including logging in, ensuring security, and remembering your cookie preferences. They cannot be disabled, as they are vital for the site’s performance.
                </li>
                <li>
                    <b>Functional Cookies:</b>
                    These cookies enhance your experience by remembering your preferences, such as language settings and account details. Disabling these cookies may limit certain features and reduce personalization.
                </li>
                <li>
                    <b>Performance (Analytical) Cookies:</b>
                    These cookies help us analyze user behavior and site usage. By gathering data on site traffic and popular pages, they enable us to enhance content quality and accessibility.
                </li>
                <li>
                    <b>Targeting (Tracking) Cookies:</b>
                    Used primarily on pages aimed at donors and partners, these cookies assist in our outreach and marketing efforts. You can opt to disable these cookies without impacting your access to the general site.
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="mb-4">3. Managing Your Cookie Preferences</h6>
            <p>You can manage your cookie settings through our Cookie Preference Center. Here, you can opt out of non-essential cookies according to your preferences; however, please note that some features may not function properly if certain cookies are disabled. Essential cookies will remain active to ensure the website operates smoothly.</p>
        </div>

        <p class="mb-4">
            Additionally, you can adjust cookie settings through your browser or device settings. For guidance, please refer to the “help” section of your browser. Keep in mind that disabling cookies may affect some functionalities of the website and reset your previous preferences.
        </p>

        <div class="inner mb-4">
            <h6 class="mb-4">4. Third-Party Cookies</h6>
            <p>
                Our website may include third-party services, such as educational content or donation platforms, that utilize their own cookies. The Dhammika & Priscilla Perera Foundation does not have control over these cookies, so we recommend managing your preferences directly on the respective third-party sites. 
            </p>
            <p>
                For more information or to adjust your preferences, please visit our Cookie Preference Center.
            </p>
            <p>
                At the Dhammika & Priscilla Perera Foundation, we are committed to providing an accessible, secure, and personalized online experience for all users. If you have any questions, please contact us at <a href="mailto:info@dpedu.org">info@dpedu.org</a>.
            </p>
        </div>
    </div>
</section>
